module.exports = __webpack_public_path__ + "img/147.2fa2a251.jpg";